module.exports = __webpack_public_path__ + "img/griffin-campus.7f82ef62.jpg";